import { request } from '@/utils/ajax';
import { MacGyverAccessLevel } from '@/services/auth';

export interface MacGyverUser {
    id: number;
    email: string;
    accessLevel: MacGyverAccessLevel;
    isActive: boolean;
    isBootstrapAdmin: boolean;
}

export interface SaveMacGyverUserRequest {
    email: string;
    accessLevel: MacGyverAccessLevel;
    isActive: boolean;
}

export function getMacGyverUsers(): Promise<MacGyverUser[]> {
    return request('api/macgyverusers').then((x) => x.json());
}

export function createMacGyverUser(req: SaveMacGyverUserRequest): Promise<MacGyverUser> {
    return request('api/macgyverusers', { json: true, body: req, method: 'POST' }).then((x) => x.json());
}

export function updateMacGyverUser(id: number, req: SaveMacGyverUserRequest): Promise<MacGyverUser> {
    return request(`api/macgyverusers/${id}`, { json: true, body: req, method: 'PUT' }).then((x) => x.json());
}

export function deactivateMacGyverUser(id: number): Promise<Response> {
    return request(`api/macgyverusers/${id}/deactivate`, { method: 'PATCH' });
}
